var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{ref:"file",staticClass:"form-control",attrs:{"type":"file","placeholder":"","hidden":"","multiple":""},on:{"change":_vm.selectFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }